import { render, staticRenderFns } from "./SupportInfoForm.vue?vue&type=template&id=0b48c86b"
import script from "./SupportInfoForm.vue?vue&type=script&lang=js"
export * from "./SupportInfoForm.vue?vue&type=script&lang=js"
import style0 from "./SupportInfoForm.vue?vue&type=style&index=0&id=0b48c86b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports